module.exports = __webpack_public_path__ + "static/your_goals_your_plan-2b2ac54b9aced8deb3cb2a7dcb7b6517.jpg";